import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Location, TitleCasePipe } from '@angular/common';
import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  effect,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDrawer } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { filter, map, shareReplay } from 'rxjs/operators';
import {
  CommCenterService,
  DisplayService,
  InpageAliasService,
  LogService,
  RecentClaimService,
  Session,
  TranslationService,
} from 'src/app/my-sedgwick';
import {
  BaseComponent,
  MessageBus,
  MyClaim,
  SelectOption,
} from 'src/app/shared';
import { Http } from 'src/app/shared/services/http.service';
import { environment } from 'src/environments/environment';
import { ConfigurationSetting, UserActionService } from '../../../shared';
import { clients, OutboundSSO, UserActions } from '../../../shared/models/user';
import { Announcements } from '../../models/announcements';
import { EulaAgreements } from '../../models/eulaagreements';
import { UserLogout } from '../../models/user-logout';
import { ClaimService } from '../../services/claim.service';
import { ConfigurationService } from '../../services/configuration.service';
import { DelegationService } from '../../services/delegation.service';
import { UserRoleService } from '../../services/user-role.service';
import { UserDetails } from '../../services/userdetails.service';
import { IClaimant } from '../labels/claimant-label.component';
import { Delegatee, Delegatees } from '../delegate/act-delegate-page.component';
import { FormGroup, UntypedFormBuilder } from '@angular/forms';
import { LogoResults } from '../../models/LogoResults';
import { OutboundSsoService } from '../../services/outbound-sso.service';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { LeaveLinkAccessService } from '../../services/leavelink-access.service';
import { TranslationPipe } from '../../pipes/translation.pipe';

@Component({
  selector: 'app-layout',
  providers: [TranslationPipe],
  template: `
    <div style="overflow-y: auto;">
      <app-skip-to-main></app-skip-to-main>
      @if (session.user && session.user.emulatorContext) {
        <app-preview-mode-header
          class="tw-w-full "
          (logOutEmitter)="logOut()"
          [translationRequest]="translationRequest"
        ></app-preview-mode-header>
      }

      @if (session.user) {
        <mat-sidenav-container class="sidenav-container app-high-density">
          <mat-sidenav
            #drawer
            class="sidenav"
            role="navigation"
            position="start"
            [attr.role]="(isSmall$ | async) ? 'dialog' : 'navigation'"
            [mode]="(isSmall$ | async) ? 'over' : 'side'"
            [opened]="
              (isSmall$ | async) === false && session.user.role !== 'AUDITOR'
            "
          >
            <div class="app-pt2" style="text-align: center"></div>
            <div class="app-pb3">
              @if (logoData) {
                @if (
                  logoData.hasClientRecord &&
                  logoData.absenceOneClient &&
                  logoData.dualLogo
                ) {
                  <img
                    src="data:image/JPEG;base64,{{
                      logoData.absenceOneLogoImg
                    }}"
                    class="tw-w-full tw-object-contain app-pl2 app-pr2"
                    alt="{{ logoData.absenceOneLogoAlt }}"
                    tabindex="0"
                    [attr.aria-label]="logoData.absenceOneLogoAlt"
                  />
                }
                @if (
                  (logoData.hasClientRecord &&
                    !logoData.absenceOneClient &&
                    logoData.dualLogo) ||
                  !logoData.hasClientRecord
                ) {
                  <img
                    src="data:image/JPEG;base64,{{ logoData.sedgwickLogoImg }}"
                    class="tw-w-full tw-object-contain app-pl2 app-pr2"
                    alt="{{ logoData.sedgwickLogoAlt }}"
                    tabindex="0"
                    [attr.aria-label]="logoData.sedgwickLogoAlt"
                  />
                }
              }
            </div>
            @if (isManager && session.user.role !== 'AUDITOR') {
              <app-sidenav
                [hasEulaAgreement]="hasEulaAgreement"
                [isIncidentalClient]="isIncidentalClient"
                [hasReportClaim]="hasReportClaim"
                [isManager]="isManager"
                [showSearch]="showSearch"
                [showWatchlist]="showWatchlist"
                [showHistory]="showHistory"
                [myClaims]="myClaims"
                [isSmall]="isSmall$"
                [isAuditor]="isAuditor"
                [drawer]="drawer"
                [actAsDelegate]="display.actAsDelegateSignal()"
                [manageDelegates]="manageDelegates"
                [manageOthersDelegators]="manageOthersDelegators"
                [IsMyWorkSchedule]="hasWorkSchedule"
              >
              </app-sidenav>
            }
            @if (
              !hasEulaAgreement &&
              !isManager &&
              !terminated &&
              session.user.role !== 'AUDITOR'
            ) {
              <mat-nav-list>
                @if (!hasEulaAgreement && display.reportClaimSignal()) {
                  <a
                    role="button"
                    tabindex="0"
                    mat-list-item
                    class="app-mat-list-item"
                    routerLinkActive
                    #rla="routerLinkActive"
                    [class.active-link]="rla.isActive"
                    [attr.aria-current]="rla.isActive ? 'page' : null"
                    [style.text-decoration]="rla.isActive ? 'underline' : null"
                    (click)="reportClaim(drawer)"
                    (keydown.enter)="reportClaim(drawer)"
                    [routerLinkActiveOptions]="{ exact: true }"
                    [attr.title]="reportClaimLabel"
                    ><span class="app-mat-list-item-span">{{
                      reportClaimLabel
                    }}</span></a
                  >
                }
                @if (!hasEulaAgreement && display.reportClaimSignal()) {
                  <mat-divider aria-hidden="true"></mat-divider>
                }
                @if (DisplayLeaveLinkSSO) {
                  <a
                    mat-list-item
                    class="app-mat-list-item"
                    routerLinkActive
                    #rla="routerLinkActive"
                    [class.active-link]="rla.isActive"
                    [attr.aria-current]="rla.isActive ? 'page' : null"
                    [style.text-decoration]="rla.isActive ? 'underline' : null"
                    routerLink=""
                    [routerLinkActiveOptions]="{ exact: true }"
                    (click)="
                      tryClose(
                        drawer,
                        null,
                        'Outbound SSO - LEAVELINK',
                        'OutboundSSO',
                        null
                      )
                    "
                    (keydown.enter)="
                      tryClose(
                        drawer,
                        null,
                        'Outbound SSO - LEAVELINK',
                        'OutboundSSO',
                        null
                      )
                    "
                    ><span class="app-mat-list-item-span"
                      >{{ LeaveLinkSSOText }}
                    </span></a
                  >
                }
                @if (DisplayLeaveLinkSSO) {
                  <mat-divider aria-hidden="true"></mat-divider>
                }
                @if (display.summaryViewValidate()) {
                  <a
                    mat-list-item
                    class="app-mat-list-item"
                    routerLink="/summary"
                    routerLinkActive
                    #rla="routerLinkActive"
                    [class.active-link]="rla.isActive"
                    [attr.aria-current]="rla.isActive ? 'page' : null"
                    [style.text-decoration]="rla.isActive ? 'underline' : null"
                    (click)="
                      tryClose(
                        drawer,
                        '/summary',
                        'Summary view',
                        'Summary',
                        null
                      )
                    "
                    [routerLinkActiveOptions]="{ exact: true }"
                    [title]="'SUMMARY VIEW' | translation: translationRequest"
                    ><span class="app-mat-list-item-span">{{
                      'Summary View' | translation: translationRequest
                    }}</span></a
                  >
                }
                @if (display.summaryViewValidate()) {
                  <mat-divider aria-hidden="true"></mat-divider>
                }
                @if (session.user.roles.supervisor) {
                  <a
                    mat-list-item
                    class="app-mat-list-item"
                    routerLinkActive
                    routerLink="/supervisor"
                    #rla="routerLinkActive"
                    [class.active-link]="rla.isActive"
                    [attr.aria-current]="rla.isActive ? 'page' : null"
                    (click)="
                      redirectToOwnMgrDashboard();
                      tryClose(
                        drawer,
                        'supervisor',
                        'Manager View',
                        'ManagerView',
                        null
                      )
                    "
                    [routerLinkActiveOptions]="{ exact: true }"
                    [style.text-decoration]="rla.isActive ? 'underline' : null"
                    [attr.aria-current]="
                      router.isActive('/supervisor', true) ? 'page' : null
                    "
                    [style.text-decoration]="
                      router.isActive('/supervisor', true) ? 'underline' : null
                    "
                    [title]="'MANAGER VIEW' | translation: translationRequest"
                    ><span class="app-mat-list-item-span">{{
                      'MANAGER VIEW' | translation: translationRequest
                    }}</span></a
                  >
                }
                @if (session.user.roles.supervisor) {
                  <mat-divider aria-hidden="true"></mat-divider>
                }
                @if (isManager) {
                  <a
                    mat-list-item
                    class="app-mat-list-item"
                    routerLinkActive
                    #rla="routerLinkActive"
                    [class.active-link]="rla.isActive"
                    [attr.aria-current]="rla.isActive ? 'page' : null"
                    [style.text-decoration]="rla.isActive ? 'underline' : null"
                    routerLink="/supervisor"
                    (click)="
                      tryClose(
                        drawer,
                        'supervisor',
                        'Manager View',
                        'ManagerView',
                        null
                      )
                    "
                    [routerLinkActiveOptions]="{ exact: true }"
                    [title]="'MANAGER VIEW' | translation: translationRequest"
                    ><span class="app-mat-list-item-span">{{
                      'MANAGER VIEW' | translation: translationRequest
                    }}</span></a
                  >
                }
                @if (isManager && !session.isDelegating()) {
                  <mat-divider aria-hidden="true"></mat-divider>
                }
                @if (
                  !session.isDelegating() &&
                  this.session.user.clientCustomizations.EmployeeDashboard
                ) {
                  <a
                    mat-list-item
                    class="app-mat-list-item"
                    routerLinkActive
                    routerLink="/dashboard"
                    #rla="routerLinkActive"
                    [class.active-link]="rla.isActive"
                    [attr.aria-current]="rla.isActive ? 'page' : null"
                    [style.text-decoration]="rla.isActive ? 'underline' : null"
                    (click)="
                      tryClose(
                        drawer,
                        getDashboardRoute(),
                        showMenu,
                        showMenu,
                        null
                      )
                    "
                    [routerLinkActiveOptions]="{ exact: true }"
                    [title]="showMenu | translation: translationRequest"
                    ><span class="app-mat-list-item-span">{{
                      showMenu.toUpperCase() | translation: translationRequest
                    }}</span></a
                  >
                }
                <mat-divider aria-hidden="true"></mat-divider>
                @if (hasWorkSchedule) {
                  <a
                    mat-list-item
                    class="app-mat-list-item"
                    (click)="
                      tryClose(
                        drawer,
                        '/my-work-schedule',
                        'My Work Schedule',
                        'MyWorkSchedule',
                        null
                      )
                    "
                    routerLinkActive
                    #rla="routerLinkActive"
                    [class.active-link]="rla.isActive"
                    [attr.aria-current]="rla.isActive ? 'page' : null"
                    [style.text-decoration]="rla.isActive ? 'underline' : null"
                    [title]="
                      'My Work Schedule' | translation: translationRequest
                    "
                    ><span class="app-mat-list-item-span">{{
                      'My Work Schedule' | translation: translationRequest
                    }}</span></a
                  >
                }
                @if (hasWorkSchedule) {
                  <mat-divider aria-hidden="true"></mat-divider>
                }
                @if (hasIncidentalAbsence()) {
                  <a
                    mat-list-item
                    class="app-mat-list-item"
                    routerLink="/absence-dashboard"
                    routerLinkActive
                    #rla="routerLinkActive"
                    [class.active-link]="rla.isActive"
                    [attr.aria-current]="rla.isActive ? 'page' : null"
                    [style.text-decoration]="rla.isActive ? 'underline' : null"
                    (click)="
                      tryClose(
                        drawer,
                        '/absence-dashboard',
                        'Absences',
                        'Absences',
                        null
                      )
                    "
                    [routerLinkActiveOptions]="{ exact: true }"
                    ><span class="app-mat-list-item-span">{{
                      'Absences' | translation: translationRequest
                    }}</span></a
                  >
                }
                @if (hasIncidentalAbsence()) {
                  <mat-divider aria-hidden="true"></mat-divider>
                }
                @if (display.commCenter) {
                  <a
                    mat-list-item
                    class="app-mat-list-item"
                    routerLink="/communication-center"
                    routerLinkActive
                    #rla="routerLinkActive"
                    [class.active-link]="rla.isActive"
                    [attr.aria-current]="rla.isActive ? 'page' : null"
                    [style.text-decoration]="rla.isActive ? 'underline' : null"
                    (click)="
                      tryClose(
                        drawer,
                        '/communication-center',
                        'Communication Center',
                        'CommunicationCenter',
                        null
                      )
                    "
                    [title]="
                      'Communication center' | translation: translationRequest
                    "
                    ><span class="app-mat-list-item-span">{{
                      'Communication center' | translation: translationRequest
                    }}</span></a
                  >
                }
                @if (display.commCenter) {
                  <mat-divider aria-hidden="true"></mat-divider>
                }
                @if (this.display.search) {
                  <a
                    mat-list-item
                    class="app-mat-list-item"
                    (click)="
                      tryClose(
                        drawer,
                        '/search',
                        'Claim Search',
                        'ClaimSearch',
                        null
                      )
                    "
                    routerLinkActive
                    routerLink="/search"
                    #rla="routerLinkActive"
                    [class.active-link]="rla.isActive"
                    [attr.aria-current]="rla.isActive ? 'page' : null"
                    [style.text-decoration]="rla.isActive ? 'underline' : null"
                    [title]="'Search' | translation: translationRequest"
                    ><span class="app-mat-list-item-span">{{
                      'Claim Search' | translation: translationRequest
                    }}</span></a
                  >
                }
                @if (this.display.search) {
                  <mat-divider aria-hidden="true"></mat-divider>
                }
                @if (showWatchlist) {
                  <a
                    mat-list-item
                    class="app-mat-list-item"
                    (click)="
                      tryClose(
                        drawer,
                        '/watchlist',
                        'Watch List',
                        'WatchList',
                        null
                      )
                    "
                    routerLinkActive
                    routerLink="/watchlist"
                    #rla="routerLinkActive"
                    [class.active-link]="rla.isActive"
                    [attr.aria-current]="rla.isActive ? 'page' : null"
                    [style.text-decoration]="rla.isActive ? 'underline' : null"
                    [title]="'Watch List' | translation: translationRequest"
                    ><span class="app-mat-list-item-span">{{
                      'Watch List' | translation: translationRequest
                    }}</span></a
                  >
                }
                @if (showWatchlist) {
                  <mat-divider aria-hidden="true"></mat-divider>
                }
                @if (showHistory) {
                  <a
                    mat-list-item
                    class="app-mat-list-item"
                    routerLink="/history"
                    (click)="
                      tryClose(drawer, '/history', 'History', 'History', null)
                    "
                    routerLinkActive
                    #rla="routerLinkActive"
                    [class.active-link]="rla.isActive"
                    [attr.aria-current]="rla.isActive ? 'page' : null"
                    [style.text-decoration]="rla.isActive ? 'underline' : null"
                    [title]="'History' | translation: translationRequest"
                    ><span class="app-mat-list-item-span">{{
                      'History' | translation: translationRequest
                    }}</span></a
                  >
                }
                @if (showHistory) {
                  <mat-divider aria-hidden="true"></mat-divider>
                }
                @if (display.actAsDelegateSignal() && !session.isDelegating()) {
                  <a
                    mat-list-item
                    class="app-mat-list-item"
                    routerLinkActive
                    routerLink="/act-as-delegate"
                    #rla="routerLinkActive"
                    [class.active-link]="rla.isActive"
                    [attr.aria-current]="rla.isActive ? 'page' : null"
                    [style.text-decoration]="rla.isActive ? 'underline' : null"
                    (click)="
                      tryClose(
                        drawer,
                        '/act-as-delegate',
                        'Act as delegate',
                        'ActAsDelegate',
                        null
                      )
                    "
                    ><span class="app-mat-list-item-span">{{
                      'Act as delegate' | translation: translationRequest
                    }}</span></a
                  >
                }
                @if (display.actAsDelegateSignal() && !session.isDelegating()) {
                  <mat-divider aria-hidden="true"></mat-divider>
                }
                @if (
                  (manageDelegates || manageOthersDelegators) &&
                  !session.isDelegating()
                ) {
                  <a
                    mat-list-item
                    class="app-mat-list-item"
                    routerLinkActive
                    #rla="routerLinkActive"
                    routerLink="/manage-delegates"
                    [class.active-link]="rla.isActive"
                    [attr.aria-current]="rla.isActive ? 'page' : null"
                    [style.text-decoration]="rla.isActive ? 'underline' : null"
                    (click)="
                      tryClose(
                        drawer,
                        '/manage-delegates',
                        'Manage Delegates',
                        'ManageDelegates',
                        null
                      )
                    "
                    ><span class="app-mat-list-item-span">{{
                      'Manage delegates' | translation: translationRequest
                    }}</span></a
                  >
                }
                @if (
                  (manageDelegates || manageOthersDelegators) &&
                  !session.isDelegating()
                ) {
                  <mat-divider aria-hidden="true"></mat-divider>
                }
                @if (!session.isDelegating()) {
                  <a
                    mat-list-item
                    class="app-mat-list-item"
                    (click)="
                      tryClose(
                        drawer,
                        '/PreferencesPage',
                        'Account settings',
                        'Accountsettings',
                        null
                      )
                    "
                    routerLink="/PreferencesPage"
                    routerLinkActive
                    #rla="routerLinkActive"
                    [class.active-link]="rla.isActive"
                    [attr.aria-current]="rla.isActive ? 'page' : null"
                    [style.text-decoration]="rla.isActive ? 'underline' : null"
                    [title]="
                      'Account settings' | translation: translationRequest
                    "
                    role="link"
                    ><span class="app-mat-list-item-span">{{
                      'Account settings' | translation: translationRequest
                    }}</span></a
                  >
                }
                @if (!session.isDelegating()) {
                  <mat-divider aria-hidden="true"></mat-divider>
                }
                @if (display.helpPage) {
                  <a
                    mat-list-item
                    class="app-mat-list-item"
                    (click)="
                      tryClose(
                        drawer,
                        'help',
                        'Helpful Resources',
                        'HelpfulResources',
                        { focus: 'learningcenter', origin: 'leftNav' }
                      )
                    "
                    routerLinkActive
                    routerLink="/help"
                    #rla="routerLinkActive"
                    [class.active-link]="rla.isActive"
                    [attr.aria-current]="rla.isActive ? 'page' : null"
                    [style.text-decoration]="rla.isActive ? 'underline' : null"
                    [title]="
                      'Helpful Resources' | translation: translationRequest
                    "
                    role="link"
                    ><span class="app-mat-list-item-span">{{
                      'Helpful Resources' | translation: translationRequest
                    }}</span></a
                  >
                }
                @if (display.helpPage) {
                  <mat-divider aria-hidden="true"></mat-divider>
                }
                <a
                  [routerLink]="[]"
                  mat-list-item
                  class="app-mat-list-item"
                  (click)="logOut()"
                  [title]="'Log out' | translation: translationRequest"
                  ><span class="app-mat-list-item-span">{{
                    'Log out' | translation: translationRequest
                  }}</span></a
                >
                @if (hostname === 'localhost') {
                  <mat-divider aria-hidden="true"></mat-divider>
                  <a
                    mat-list-item
                    class="app-mat-list-item"
                    routerLinkActive
                    #rla="routerLinkActive"
                    [class.active-link]="rla.isActive"
                    [attr.aria-current]="rla.isActive ? 'page' : null"
                    [style.text-decoration]="rla.isActive ? 'underline' : null"
                    routerLink="design"
                    [title]="'design' | translation: translationRequest"
                    ><span class="app-mat-list-item-span">{{
                      'Design' | translation: translationRequest
                    }}</span></a
                  >
                }
              </mat-nav-list>
            }
          </mat-sidenav>
          <mat-sidenav-content
            [class]="(isSmall$ | async) ? 'contentmini' : 'contentmax'"
            (scroll)="onScroll($event)"
          >
            <div class="tw-flex tw-flex-col inflate-body">
              @if (
                session.user &&
                session.user.emulatorContext &&
                !hideEmulatedUserHeader
              ) {
                <app-emulate-user-header
                  class="tw-w-full"
                  [isSmall$]="isSmall$"
                  [isAuditor]="isAuditor"
                  [showHeaderIcons]="showHeaderIcons"
                  [showSearch]="showSearch"
                  [showWatchlist]="showWatchlist"
                  [showHistory]="showHistory"
                  [hasEulaAgreement]="hasEulaAgreement"
                  [isPreference]="isPreference"
                  [scrolled]="scrolled"
                  (logOutEmitter)="logOut()"
                  [drawer]="drawer"
                  [translationRequest]="translationRequest"
                >
                </app-emulate-user-header>
              }
              <div
                class="tw-grid tw-grid-cols-1 tw-justify-items-center header toolbar"
                role="banner"
                style="z-index:999;"
                [class.mat-elevation-z4]="scrolled"
              >
                <div id="imagelogoabove">
                  @if (
                    isInternalAuditor &&
                    clientsLoaded &&
                    accessclients.length > 0
                  ) {
                    <div class="clientname">
                      {{ clientHeader }}
                    </div>
                  }
                </div>
                @if (!session.user.emulatorContext) {
                  <mat-toolbar
                    id="headerContext"
                    color="primary"
                    class="header tw-max-w-screen-xl last-head-bar"
                  >
                    <div
                      class="tw-flex tw-w-full md:tw-w-1/4 tw-max-h-[100px] app-pt1 app-pb1 tw-items-center "
                    >
                      <app-logos></app-logos>
                    </div>
                    @if (
                      isInternalAuditor &&
                      clientsLoaded &&
                      accessclients.length === 0
                    ) {
                      <div class="tw-p-2">
                        <app-toast type="Warning" class="tw-text-sm">
                          <span>
                            You do not have access to any active client.
                          </span>
                        </app-toast>
                      </div>
                    }
                    @if (
                      isInternalAuditor &&
                      clientsLoaded &&
                      accessclients.length === 1
                    ) {
                      <div class="">
                        {{ 'Client' | translation: translationRequest }} :
                        {{ clientHeader }}
                      </div>
                    }
                    @if (isInternalAuditor && accessclients.length > 1) {
                      <div class="md:tw-w-[40%] tw-w-full">
                        <form
                          [formGroup]="formGroup"
                          class="tw-flex tw-flex-wrap"
                        >
                          <span class="tw-hidden md:tw-block app-pt2 app-pl2">
                            {{ 'Clients' | translation: translationRequest }} :
                            &nbsp;
                          </span>
                          <app-select-control
                            formControlName="clients"
                            label="Select client"
                            [formGroup]="formGroup"
                            [options]="accessclients"
                            ngDefaultControl
                            class="md:tw-w-[80%] tw-w-full"
                            [className]="'app-pt1'"
                            [translationNeeded]="false"
                          />
                        </form>
                      </div>
                    }
                    <span class="example-spacer"></span>
                    @if (session.isDelegating()) {
                      <div
                        class="tw-py-0.5 tw-pl-1 tw-pr-2 tw-rounded tw-border-2 tw-border-solid tw-border-[#d22828] tw-w-fit tw-flex tw-items-center tw-text-[13px] tw-leading-tight tw-mr-2"
                      >
                        <mat-icon class="tw-text-[#8586f8] tw-mr-1"
                          >people_alt</mat-icon
                        >
                        <div>
                          <div>
                            {{
                              'Delegating as' | translation: translationRequest
                            }}
                            {{ delegateeName }}
                          </div>
                          <a
                            tabindex="0"
                            (click)="endDelegationConfirmation()"
                            (keydown.enter)="endDelegationConfirmation()"
                            >{{
                              'Stop delegation'
                                | translation: translationRequest
                            }}</a
                          >
                        </div>
                        <ng-template #removeDialog let-element="element">
                          <app-dialog-container
                            [headerId]="'confirmEndDelegation'"
                            label="Confirm end delegation"
                            [headerLevel]="2"
                            [showHeader]="true"
                          >
                            <div class="tw-py-6">
                              {{
                                'The action you selected will end your delegate session and any unsaved data will be lost.'
                                  | translation: translationRequest
                              }}
                              <br />
                              {{
                                'To stop acting as a delegate, press the Confirm button below.'
                                  | translation: translationRequest
                              }}
                            </div>
                            <app-action-row>
                              <app-button
                                emphasis="High"
                                right2
                                matDialogClose
                                (click)="endDelegation($event)"
                                (keydown.enter)="endDelegation($event)"
                                label="Confirm"
                              ></app-button>
                              <app-button
                                emphasis="Low"
                                right1
                                matDialogClose
                                label="Cancel"
                              ></app-button>
                            </app-action-row>
                          </app-dialog-container>
                        </ng-template>
                      </div>
                    }
                    @if ((isSmall$ | async) && !this.isAuditor) {
                      <button
                        type="button"
                        [attr.aria-label]="
                          'Toggle sidenav' | translation: translationRequest
                        "
                        mat-icon-button
                        (click)="drawer.toggle()"
                      >
                        <mat-icon aria-label="Side nav toggle icon"
                          >menu</mat-icon
                        >
                      </button>
                    }
                    <mat-icon class="persondisplay app-icon">person</mat-icon>
                    <div
                      class="app-pr3 app-pl1 tw-font-bold tw-text-[var(--sed-black-80-color)] "
                    >
                      {{ getUserDisplayName() }}
                    </div>
                    @if (this.session.user.clientCustomizations.LoadDashboard) {
                      <div>
                        <button
                          [title]="'Home' | translation: translationRequest"
                          [attr.aria-label]="
                            'Home' | translation: translationRequest
                          "
                          mat-icon-button
                          (keydown.enter)="
                            openTopHeaderNavigation(
                              '',
                              'Home',
                              'Home',
                              'Header Navigation'
                            )
                          "
                          (click)="
                            openTopHeaderNavigation(
                              '',
                              'Home',
                              'Home',
                              'Header Navigation'
                            )
                          "
                        >
                          <mat-icon aria-hidden="false">home</mat-icon>
                        </button>
                      </div>
                    }
                    @if (!isAuditor && display.commCenter) {
                      <div
                        class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-0.5"
                      >
                        <button
                          mat-icon-button
                          [attr.aria-label]="
                            ('Communication center'
                              | translation: translationRequest) +
                            ' - ' +
                            commCenterService.unreadMessageCount() +
                            ' ' +
                            ('New messages' | translation: translationRequest)
                          "
                          class="nopadding"
                          (click)="
                            openTopHeaderNavigation(
                              '/communication-center',
                              'Communication Center - Count - ' +
                                commCenterService.unreadMessageCount(),
                              'CommunicationCenter',
                              'Header Navigation'
                            )
                          "
                          role="link"
                          tabindex="0"
                          [attr.title]="
                            ('Communication center'
                              | translation: translationRequest) +
                            ' - ' +
                            commCenterService.unreadMessageCount() +
                            ' ' +
                            ('New messages' | translation: translationRequest)
                          "
                        >
                          <mat-icon
                            [matBadge]="commCenterService.unreadMessageCount()"
                            matBadgeColor="accent"
                            aria-hidden="false"
                            >mail_outline</mat-icon
                          >
                        </button>
                      </div>
                    }
                    @if (PasswordNotification) {
                      <div
                        class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-0.5"
                      >
                        <app-overlay
                          [origin]="passwordNotificationOverlayOrigin"
                          #passwordNotificationOverlay
                          [overlayClassName]="
                            'tw-w-[420px] tw-max-w-[min(90vw,420px)]'
                          "
                        >
                          @if (
                            passwordNotificationOverlay.opened &&
                            PasswordExpireInDays > -1
                          ) {
                            <app-panel [showTitle]="false" [canExpand]="false">
                              <div class="app-pt1 tw-pb-2">
                                <a
                                  class="tw-m-0"
                                  (click)="
                                    openTopHeaderNavigation(
                                      '',
                                      'changepassword',
                                      'Accountsettings',
                                      'Header Navigation'
                                    )
                                  "
                                >
                                  {{
                                    PasswordExpirationNotificationMessage
                                      | translation: translationRequest
                                  }}
                                </a>
                              </div>
                            </app-panel>
                          }
                        </app-overlay>
                        <button
                          type="button"
                          mat-icon-button
                          cdkOverlayOrigin
                          #passwordNotificationOverlayOrigin="cdkOverlayOrigin"
                          class="password-notification-header-btn tw-rounded-full tw-h-6 tw-w-6"
                          [attr.aria-label]="
                            'Password notification'
                              | translation: translationRequest
                          "
                          [attr.title]="
                            'Password notification'
                              | translation: translationRequest
                          "
                          [attr.aria-expanded]="
                            passwordNotificationOverlay.opened
                              ? 'true'
                              : 'false'
                          "
                          (click)="
                            passwordNotificationOverlay.openAndLogFeature(
                              'Password notification',
                              'Password Notification Overlay'
                            )
                          "
                        >
                          <mat-icon aria-hidden="false">warning</mat-icon>
                        </button>
                      </div>
                    }
                    @if (showHeaderIcons) {
                      <div>
                        @if (showSearch) {
                          <app-overlay
                            [origin]="searchOverlayOrigin"
                            #searchOverlay
                            [overlayClassName]="'tw-w-[600px]'"
                          >
                            @if (searchOverlay.opened) {
                              <app-quick-search
                                [showTitle]="false"
                              ></app-quick-search>
                            }
                          </app-overlay>
                          <button
                            [title]="
                              'Search Popup' | translation: translationRequest
                            "
                            [attr.aria-label]="
                              'Search Popup' | translation: translationRequest
                            "
                            mat-icon-button
                            cdkOverlayOrigin
                            #searchOverlayOrigin="cdkOverlayOrigin"
                            (click)="
                              searchOverlay.openAndLogFeature(
                                'Search',
                                'Search Overlay'
                              )
                            "
                          >
                            <mat-icon class="">search</mat-icon>
                          </button>
                        }
                      </div>
                    }
                    @if (showHeaderIcons) {
                      <div class="tw-hidden md:tw-block">
                        @if (showWatchlist && !session.isDelegating()) {
                          <app-overlay
                            [origin]="watchListOverlayOrigin"
                            #watchListOverlay
                            [overlayClassName]="'watchlist-overlay'"
                          >
                            @if (watchListOverlay.opened) {
                              <app-watch-list
                                [overlay]="true"
                                [translationRequest]="translationRequest"
                              ></app-watch-list>
                            }
                          </app-overlay>
                          <button
                            mat-icon-button
                            [title]="
                              'Watch List Popup'
                                | translation: translationRequest
                            "
                            [attr.aria-label]="
                              'Watch List Popup'
                                | translation: translationRequest
                            "
                            cdkOverlayOrigin
                            #watchListOverlayOrigin="cdkOverlayOrigin"
                            (click)="
                              watchListOverlay.openAndLogFeature(
                                'WatchList',
                                'Watch List Overlay'
                              )
                            "
                          >
                            <mat-icon>star</mat-icon>
                          </button>
                        }
                        @if (showHistory && !session.isDelegating()) {
                          <app-overlay
                            [overlayClassName]="'history-overlay'"
                            [origin]="historyOverlayOrigin"
                            #historyOverlay
                          >
                            @if (historyOverlay.opened) {
                              <app-claim-history
                                [overlay]="true"
                              ></app-claim-history>
                            }
                          </app-overlay>
                          <button
                            [title]="
                              'History Popup' | translation: translationRequest
                            "
                            [attr.aria-label]="
                              'History Popup' | translation: translationRequest
                            "
                            mat-icon-button
                            cdkOverlayOrigin
                            #historyOverlayOrigin="cdkOverlayOrigin"
                            (click)="
                              historyOverlay.openAndLogFeature(
                                'History',
                                'History Overlay'
                              )
                            "
                          >
                            <mat-icon class="">history</mat-icon>
                          </button>
                        }
                      </div>
                    }
                    @if (
                      (display.actAsDelegateSignal() ||
                        manageDelegates ||
                        manageOthersDelegators) &&
                      !this.session.isDelegating()
                    ) {
                      <div>
                        <button
                          [title]="
                            (delegationService.hasDelegationExpiringSoon()
                              ? 'Delegate Settings – Expiring Soon'
                              : 'Delegate Settings'
                            ) | translation: translationRequest
                          "
                          mat-icon-button
                          [attr.aria-label]="
                            (delegationService.hasDelegationExpiringSoon()
                              ? 'Delegate Settings – Expiring Soon'
                              : 'Delegate Settings'
                            ) | translation: translationRequest
                          "
                          [matMenuTriggerFor]="delegateMenu"
                        >
                          <mat-icon
                            matBadge="!"
                            [matBadgeHidden]="
                              !delegationService.hasDelegationExpiringSoon()
                            "
                            matBadgeColor="accent"
                            >people_alt</mat-icon
                          >
                        </button>
                        <mat-menu #delegateMenu="matMenu">
                          @if (display.actAsDelegateSignal()) {
                            <button
                              mat-menu-item
                              routerLink="/act-as-delegate"
                              (click)="
                                openTopHeaderNavigation(
                                  '/act-as-delegate',
                                  'Account settings',
                                  'Accountsettings',
                                  'Header Navigation'
                                )
                              "
                            >
                              {{
                                'Act as delegate'
                                  | translation: translationRequest
                              }}
                            </button>
                          }
                          @if (manageDelegates || manageOthersDelegators) {
                            <button
                              mat-menu-item
                              (click)="
                                openTopHeaderNavigation(
                                  '/manage-delegates',
                                  'Manage Delegates',
                                  'ManageDelegates',
                                  'Header Navigation'
                                )
                              "
                            >
                              {{
                                'Manage delegates'
                                  | translation: translationRequest
                              }}
                            </button>
                          }
                        </mat-menu>
                      </div>
                    }
                    @if (!hasEulaAgreement && !session.isDelegating()) {
                      <div>
                        @if (!isPreference) {
                          <button
                            mat-icon-button
                            id="preferenceButtonId"
                            [title]="
                              'Account settings'
                                | translation: translationRequest
                            "
                            [attr.aria-label]="
                              'Account settings'
                                | translation: translationRequest
                            "
                            mat-icon-button
                            (keydown.enter)="
                              openTopHeaderNavigation(
                                '',
                                'Account settings',
                                'Accountsettings',
                                'Header Navigation'
                              )
                            "
                            (click)="
                              openTopHeaderNavigation(
                                '',
                                'Account settings',
                                'Accountsettings',
                                'Header Navigation'
                              )
                            "
                            role="link"
                          >
                            <mat-icon class="">settings</mat-icon>
                          </button>
                        }
                      </div>
                    }
                    @if (!hasEulaAgreement) {
                      <div>
                        <button
                          mat-button
                          class="logout"
                          [title]="
                            'Logout and open the login page'
                              | translation: translationRequest
                          "
                          [attr.aria-label]="
                            'Logout and open the login page'
                              | translation: translationRequest
                          "
                          (click)="logOut()"
                        >
                          <b>{{
                            'Log out' | translation: translationRequest
                          }}</b>
                        </button>
                      </div>
                    }
                  </mat-toolbar>
                }
              </div>
              @if (session.user) {
                <div id="main-content" role="main" class="outlet tw-grow">
                  <div class="outlet">
                    @if (hasEulaAgreement) {
                      <div>
                        <app-panel
                          title="User Agreement and License"
                          [headerLevel]="1"
                          [canExpand]="false"
                        >
                          <app-enduser-licenseagreement
                            [hasEulaAgreement]="true"
                            (acceptedEulaAgreement)="
                              acceptedEulaAgreement($event)
                            "
                            [eulaAgreements]="eulaAgreements"
                            [translationRequest]="translationRequest"
                          >
                          </app-enduser-licenseagreement>
                        </app-panel>
                      </div>
                    }
                    @if (this.session.user.isEmulating || !hasEulaAgreement) {
                      <div>
                        <ng-template #dialogAnnouncements>
                          <app-dialog
                            title="{{ 'Announcements' }}"
                            ariaLabel="Announcements dialog"
                            [width]="700"
                            [showActions]="false"
                            [showHeader]="true"
                            ariaLabelMessage="Close announcement popup"
                          >
                            <hr
                              style="color:#D2D8E1 !important;margin-top: -20px;"
                            />
                            <br />
                            <app-announcements></app-announcements>
                          </app-dialog>
                        </ng-template>
                        <router-outlet></router-outlet>
                        <div class="tw-h-10"></div>
                      </div>
                    }
                  </div>
                </div>
              }
              <app-footer
                [translationRequest]="translationRequest"
              ></app-footer>
              <ng-template #dialogReportNewClaim>
                <app-dialog
                  title="{{ 'Confirmation' | sentenceCase }}"
                  ariaLabel="Confirmation dialog"
                  [width]="700"
                  [showActions]="false"
                  [showHeader]="false"
                  ariaLabelMessage="Close announcement popup"
                >
                  <app-report-new-claim></app-report-new-claim>
                </app-dialog>
              </ng-template>
              <ng-template #dialogReportNewClaimList>
                <app-dialog
                  title="{{ 'Confirmation' | sentenceCase }}"
                  ariaLabel="Confirmation dialog"
                  [showActions]="false"
                  ariaLabelMessage="Close announcement popup"
                >
                  <app-claim-list-report-absence
                    [claims]="this.myClaims"
                    [showContinue]="true"
                    [redirectToSmartly]="true"
                  ></app-claim-list-report-absence>
                </app-dialog>
              </ng-template>
            </div>
          </mat-sidenav-content>
        </mat-sidenav-container>
      }

      <ng-template #dialogLogoutConfirmation>
        <app-dialog
          [showHeader]="false"
          ariaLabel="Logout confirmation dialog | translation:translationRequest"
          [width]="700"
          [showActions]="false"
          ariaLabelMessage="Close logout confirmation popup | translation:translationRequest"
        >
          <app-end-claimant-preview></app-end-claimant-preview>
        </app-dialog>
      </ng-template>
    </div>
  `,
  styles: [
    `
      @media (max-width: 480px) {
        .stick {
          position: fixed !important;
          border-bottom: 1px solid #e0e0e0;
        }
      }

      .stick h2 {
        padding-top: 20px;
      }

      .sidenav-container {
        overflow-y: auto;
        height: 100%;
      }
      .loading-container {
        height: 100%;
        color: var(--color-input-grey);
        font-size: 14px;
      }
      /* TODO(mdc-migration): The following rule targets internal classes of list that may no longer apply for the MDC version. */
      ::ng-deep .mat-list-item-content {
        justify-content: center !important;
      }
      mat-divider {
        border-top-color: var(--sed-black-60-color) !important;
        margin-left: 20px;
        margin-right: 20px;
      }
      mat-sidenav-content {
        height: 100vh;
      }
      .contentmini {
        height: 100%;
      }
      .contentmax {
        height: 100vh;
      }
      ::ng-deep .mat-list-item {
        font-size: 0.8125em;
        font-weight: bold;
        color: white !important;
        letter-spacing: 0.2em;
        text-align: center;
      }

      .mdc-list-item__content {
        text-align: center;
      }

      .app-mat-list-item {
        text-align: center;
      }

      ::ng-deep .mat-mdc-list-item-unscoped-content {
        font-size: 0.8125em;
        font-weight: 700 !important;
        color: #fff !important;
        letter-spacing: 0.2em;
        text-align: center;
        text-transform: uppercase;
      }

      ::ng-deep .mat-progress-spinner circle,
      .mat-spinner circle {
        stroke: var(--color-sedgwick-blue);
      }
      .outlet {
        --max-width: 1280px;
        background-color: #f5f6f7;
      }

      .sidenav {
        width: 300px;
        background-color: var(--sed-engaged-black-color);
        color: white;
      }

      .sidenav .mat-toolbar {
        background: inherit;
      }

      .mat-toolbar.mat-primary {
        position: sticky;
        top: 0;
        z-index: 1;
        min-height: 64px;
      }

      .mat-toolbar {
        position: relative;
      }

      .toolbar {
        position: sticky;
        top: 0;
        z-index: 1;
        border-bottom: 1px solid #e0e0e0;
      }

      .more {
        position: absolute;
        width: 100%;
        bottom: 0;
      }

      .more-label {
        margin: 0 auto;
        z-index: 1;
        width: 70px;
        text-align: center;
        border-radius: 4px;
        padding: 4px;
        color: var(--color-accent);
        font-weight: bold;
        margin-bottom: 8px;
        background-color: white;
        border: 1px solid var(--color-accent);
      }

      .logo-image {
        padding-left: 50px;
        padding-right: 50px;
        padding-top: 20px;
      }

      .inflate-body {
        min-height: 100vh;
      }

      @media (max-width: 760px) {
        .footer {
          width: 100%;
          text-align: center;
        }
      }
      .example-spacer {
        flex: 1 1 auto;
      }

      /* mySedgwick warning pattern: Status Yellow + Warm White icon (matches snackbar-warning) */
      .password-notification-header-btn {
        background-color: var(--sed-status-yellow-color) !important;
        width: 24px !important;
        height: 24px !important;
        padding: 0 !important;
        line-height: 24px !important;
      }

      .password-notification-header-btn:hover {
        filter: brightness(0.92);
      }

      .password-notification-header-btn mat-icon {
        color: var(--sed-warm-white-color) !important;
        font-size: 16px !important;
        width: 16px !important;
        height: 16px !important;
        line-height: 16px !important;
      }

      .content {
        background-color: var(--sed-warm-white-color);
      }

      .mat-mdc-toolbar {
        position: relative;
      }

      .app-sidenav-header {
        color: var(--color-sedgwick-blue);
        font-size: 16px;
        font-weight: bold;
        justify-content: center !important;
        letter-spacing: 0.1em;
      }

      .overlay {
        width: 800px;
      }

      .header {
        background-color: var(--sed-warm-white-color);
        color: var(--sed-black-80-color);
      }

      .header-xs {
        background-color: var(--sed-warm-white-color);
      }

      mat-mdc-nav-list a {
        text-transform: uppercase;
      }

      @media only screen and (max-device-width: 480px) {
        .clientname {
          display: none !important;
        }

        .mobscreensearch {
          margin-left: -40%;
          margin-top: 10%;
        }

        .mobscreen {
          margin-top: 10%;
        }

        .fixtoolbar {
          position: sticky;
          top: 64px;
          z-index: 999999999;
          min-height: 64px;
        }
        .fixheadertoolbar {
          position: sticky !important;
        }
      }

      .flex-left {
        width: 30%;
        float: left;
      }
      .flex-right {
        width: 0%;
      }
      .flex-mid {
        width: 60%;
        display: flex;
        flex-direction: column;
        text-align: center;
        float: left;
      }

      .lnks-mt {
        margin-top: 15px;
      }
      .lnks-inner-mt {
        margin-top: 5px;
      }
      .prev-mode {
        width: 100vw !important;
      }
      .prev-mode-nav {
        margin-top: 63px;
      }
      .divider {
        outline: 3px solid grey !important;
        margin-left: 0px;
        margin-right: 0px;
      }

      .logo-above {
        max-width: 100%;
        padding-left: 20px;
        height: 62px;
      }
      .logo-inline {
        min-width: 324px;
        max-width: 100%;
        height: 62px;
      }

      .last-head-bar {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
      }

      .mat-toolbar-row,
      .mat-toolbar-single-row {
        min-height: 64px;
        height: auto !important;
      }
    `,
  ],
  standalone: false,
})
export class LayoutComponent
  extends BaseComponent
  implements OnInit, AfterContentChecked
{
  development = false;
  scrolled = false;
  isPreference = false;
  hasReportClaim = false;
  showSummaryView = false;
  isIncidentalClient = false;
  isClaimant = false;
  isEmployee = false;
  showHistory = true;
  showHome = false;
  showWatchlist = true;
  showSearch = true;
  showMyClaims = false;
  showReportClaim: boolean = true;
  showDelegation: boolean = true;
  showHeaderIcons = false;
  welcomeMessageInfo: any;
  isAuditor = false;
  isInternalAuditor = false;
  hideEmulatedUserHeader = false;
  myClaims: MyClaim[];
  isManager: boolean = false;
  terminated: boolean = false;
  accessclients: SelectOption[] = [];
  private auditorClients: clients[] = [];
  clientsLoaded: boolean = false;

  clientHeader: string;
  hasEulaAgreement: any = undefined;
  reportClaimLabel: string = '';

  @ViewChild('dialogAnnouncements') dialogRefAnnouncements: TemplateRef<any>;
  @ViewChild('dialogReportNewClaim') dialogRefReportNewClaim: TemplateRef<any>;
  @ViewChild('dialogReportNewClaimList')
  dialogRefReportNewClaimList: TemplateRef<any>;
  @ViewChild('dialogLogoutConfirmation')
  dialogRefLogoutConfirmation: TemplateRef<any>;

  eulaAgreements: EulaAgreements[];
  eulaAgreementtext = '';
  userLogout: UserLogout;
  isSupervisorRole: boolean = false;
  claimant: IClaimant | null;
  mgrAction: UserActions | null;
  hasWorkSchedule: boolean = false;

  isController: boolean = false;
  showMenu: string = 'My claims';
  announcements: Announcements[];
  delegationEnabled: boolean = false;
  canActAsDelegatee: boolean = false;
  canManageOwnDelegates = false;
  canManageDelegators = false;
  clientLevelConfig: ConfigurationSetting;

  isSmall$: Observable<boolean> = this.breakpointObserver
    .observe([Breakpoints.Medium, Breakpoints.Small, Breakpoints.XSmall])
    .pipe(
      map((result) => result.matches),
      shareReplay(),
    );
  empUnum: string;
  isEmpDb: boolean;
  delegateeName: string;
  messageTitle: string;
  messageCount: number;
  outboundSSO: OutboundSSO[] = [];
  showDelegationMenu = false;
  manageDelegates = false;
  actAsDelegate = false;
  manageOthersDelegators = false;
  hostname = window.location.hostname;
  stoppingEmulation = false;
  logoData: LogoResults;
  showLeavelinkSSO: boolean = false;
  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });

  @ViewChild('removeDialog') removeDialog: TemplateRef<any>;

  get LeaveLinkSSOText(): string {
    const ind = this.display?.outboundSSO.findIndex(
      (x) => x.ssoType.toLowerCase() == 'leavelink',
    );
    if (ind > -1) {
      return this.transPipe.transform(
        this.display?.outboundSSO[0]?.ssoLinkEmployee,
        this.translationRequest,
      );
    } else {
      return '';
    }
  }
  get PasswordExpireInDays(): number {
    if(this.session.user.passwordInDays == null || this.session.user.passwordInDays == undefined) {
      return -1;
    }
    return this.session.user.passwordInDays;
  }

  get PasswordExpirationNotificationMessage(): string {
    const passwordExpireInDays = this.PasswordExpireInDays;
    if (passwordExpireInDays <= 0) {
      return 'Password expires today.';
    }
    if (passwordExpireInDays === 1) {
      return 'Password expires in 1 day.';
    }
    return `Password expires in ${passwordExpireInDays} days.`;
  }

  get PasswordNotification(): boolean {
    if(this.session.user.passwordInDays == null || this.session.user.passwordInDays == undefined || this.session.user.passwordInDays < 0) {
      return false;
    }

    if(this.session.user.userType == 'SSO') {
      return false;
    }
    
    return this.session.user.passwordInDays < 8;
  }
  get DisplayLeaveLinkSSO(): boolean {
    if (
      this.display?.outboundSSO != null &&
      this.display?.outboundSSO != undefined &&
      this.display?.outboundSSO.length > 0
    ) {
      const ind = this.display?.outboundSSO.findIndex(
        (x) => x.ssoType.toLowerCase() == 'leavelink',
      );
      if (ind > -1) {
        if (this.display?.outboundSSO[ind]?.allowLeftNav) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  formGroup: FormGroup = this.fb.group({
    clients: [],
  });

  constructor(
    private breakpointObserver: BreakpointObserver,
    public router: Router,
    private recentClaimService: RecentClaimService,
    public session: Session,
    public userdetails: UserDetails,
    public dialog: MatDialog,
    private http: Http,
    private config: ConfigurationService,
    public logService: LogService,
    private messageBus: MessageBus,
    private claimService: ClaimService,
    private userAction: UserActionService,
    public display: DisplayService,
    public delegationService: DelegationService,
    private titleCase: TitleCasePipe,
    public userRole: UserRoleService,
    private cookieService: CookieService,
    private delegateService: DelegationService,
    public commCenterService: CommCenterService,
    public inpageAliasService: InpageAliasService,
    private fb: UntypedFormBuilder,
    public outboundSsoService: OutboundSsoService,
    public translationService: TranslationService,
    private leaveLinkAccessService: LeaveLinkAccessService,
    private changeDetectorRef: ChangeDetectorRef,
    private transPipe: TranslationPipe,
    private aliases: InpageAliasService,
  ) {
    super();
    this.eulaAgreements = new Array<EulaAgreements>();
    this.development = !environment.production;
    this.subs.sink = this.messageBus
      .topic('layout:report-claim')
      .subscribe((value) => {
        this.reportClaim(null);
      });
    this.subs.sink = this.delegationService.delegateName$.subscribe((name) => {
      this.delegateeName = name;
    });
    effect(() => {
      this.delegationService.hasDelegationExpiringSoon();
      this.changeDetectorRef.markForCheck();
    });

    if (this.cookieService.get('ClearSessionStorage') === 'true') {
      this.cookieService.delete('ClearSessionStorage');
      sessionStorage.clear();
    }

    document.addEventListener('scroll', (ev) => {
      const deviceWidth = window.innerWidth;
      const headerContext = document.getElementById('headerContext');
      const imageLogoAbove = document.getElementById('imagelogoabove');

      if (deviceWidth <= 480) {
        if (window.scrollY > 30) {
          if (headerContext) {
            headerContext.setAttribute('style', 'position: fixed !important');
          }
        } else {
          if (imageLogoAbove) {
            imageLogoAbove.setAttribute('style', 'display:block');
          }
          if (headerContext) {
            headerContext.setAttribute(
              'style',
              'position: relative !important',
            );
          }
        }
      } else {
        if (headerContext) {
          headerContext.removeAttribute('style');
        }
        if (imageLogoAbove) {
          imageLogoAbove.removeAttribute('style');
        }
      }
    });
  }

  async getAccessClients() {
    const opts = await this.session.getInternalAuditorClientsList();
    this.auditorClients = opts;
    const opts1 = opts.map((r) => {
      return {
        label: r.clientName + ' - ' + r.contNum,
        value: r.contNum,
      } as SelectOption;
    });

    this.session.user.clients = opts1;
    this.accessclients = opts1;
    this.clientsLoaded = true;

    if (opts.length === 1) {
      this.session.user.contNum = opts[0].contNum;
      this.session.SetSelectedClient(opts[0].contNum, opts[0].clientName);
    }
  }

  ngAfterContentChecked() {
    this.translationService.translations$.subscribe(() => {
      this.changeDetectorRef.detectChanges();
    });
  }

  async ngOnInit() {
    if (this.session.SelectedUpdatedContNum != '-1') {
      const clientData = this.accessclients.filter(
        (item) => item.value === this.session.SelectedUpdatedContNum,
      );
      this.session.SetSelectedClient(clientData[0].value, clientData[0].label);
    }
    await this.session.loadUser();
    this.isManager = this.session.user.roles.manager;
    this.isController = this.session.user.roles.controller;
    this.logoData = await this.session.GetLogoDetails();

    const defaultLang = await this.translationService.getDefaultLangauge();
    await this.translationService.setDefaultLanguage(defaultLang);

    // remove after pepsico transistions to 5.0
    if (
      this.session.user.isDelegating &&
      this.session.user.delegateeContext == null &&
      !this.session.isAuditorPreview
    ) {
      const delegators: Delegatees = await this.delegateService.getDelegators(
        this.session.user.empUnum,
      );
      const delegatee = delegators.delegatees.find(
        (delegatee: Delegatee) =>
          delegatee.delegatorEmpUnum === this.session.user.delegatorEmpUnum,
      );
      await this.session.startDelegation(delegatee);
    }
    if (
      this.session.isDelegating() &&
      this.session.user.delegateeContext != null
    ) {
      this.delegateeName =
        this.session.user.firstName + ' ' + this.session.user.lastName;
    }

    this.outboundSSO = this.display.outboundSSO;
    if (
      this.outboundSSO != undefined &&
      this.outboundSSO != null &&
      this.outboundSSO.length > 0
    ) {
      const indx = this.outboundSSO.findIndex((x) => x.ssoType == 'leavelink');
      if (indx > -1) {
        this.showLeavelinkSSO = this.outboundSSO[indx].allowLeftNav;
      } else {
        this.showLeavelinkSSO = false;
      }
    } else {
      this.showLeavelinkSSO = false;
    }
    // remove after pepsico transistions to 5.0
    await this.loadDelegationFeatures();
    this.isSupervisorRole = this.session.user.roles.supervisor;
    this.isManager = this.session.user.roles.manager;
    this.isController = this.session.user.roles.controller;
    this.terminated = this.session.user.emulatorContext?.isTerminated;

    this.hasWorkSchedule = this.display.myWorkSchedule;

    if (this.isManager || this.session.user.roles.controller) {
      await this.recentClaimService.initWatchList(); //call watchlist to populate signal
    }

    if (this.isManager) {
      this.mgrAction = this.userAction.getAction();
      if (this.mgrAction == UserActions.MgrViewEmpDb) {
        this.claimant = this.userAction.getClaimant();
        if (this.claimant?.empUnum) {
          this.empUnum = this.claimant.empUnum;
          this.isEmpDb = true;
        }
      }
    }

    if (this.isController) {
      this.showMenu = 'Manager View';
    }
    this.hideEmulatedUserHeader = false;

    await this.refreshValues();

    if (this.isInternalAuditor) {
      await this.getAccessClients();
    }

    if (this.session.user.role === 'AUDITOR' || this.session.user.isEmulating) {
      this.subs.sink = this.session.isEmulating$.subscribe(async () => {
        await this.refreshValues();
        await this.loadDelegationFeatures();
      });
    }
    if (!this.session.user.clientCustomizations.LoadDashboard) {
      this.router.navigate(['absence-dashboard']);
    }

    let data: EulaAgreements[] = [];
    if (
      !this.session.user.userType.includes('EMULATION') ||
      !this.session.user.isEmulating
    ) {
      const agreaments = await this.http.get<EulaAgreements[]>(
        `/api/user/Eula/eulaagreements`,
      );
      data = agreaments;
    }

    if (
      data &&
      data.length > 0 &&
      !this.isIncidentalClient &&
      (this.session.user.emulatorContext == null ||
        (this.session.user.emulatorContext != null &&
          !this.session.user.emulatorContext.isEmulating))
    ) {
      const eulaAccepted = sessionStorage.getItem('eulaAccepted') === 'true';
      if (!eulaAccepted) {
        data.forEach((element) => {
          this.eulaAgreements.push(element);
        });
        this.hasEulaAgreement = true;
      } else {
        this.hasEulaAgreement = false;
        this.displayAnnouncements();
      }
    } else {
      this.hasEulaAgreement = false;
      this.displayAnnouncements();
    }

    this.showHeaderIcons =
      !this.hasEulaAgreement && !this.isClaimant && !this.isEmployee
        ? true
        : false;

    this.subs.sink = this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe(() => {
        // scroll the content back to the top on navigationEnd
        document.querySelector('.sidenav-container') != null
          ? (document.querySelector('.sidenav-container').scrollTop = 0)
          : null;
      });

    this.clientHeader = this.session.clientHeader;

    if (
      this.userAction.getAction() !== UserActions.MgrViewEmpClaim &&
      this.userAction.getAction() !== UserActions.MgrViewEmpSubpage &&
      this.userAction.getAction() !== UserActions.MgrViewOwnSubpage &&
      this.userAction.getAction() !== UserActions.ViewOwnMgrDb &&
      !this.userRole.auditor
    ) {
      if (this.isEmpDb && this.claimant?.empUnum) {
        this.myClaims = await (<any>(
          this.claimService.getClaimsEmpUNum(this.claimant?.empUnum)
        ));
      } else {
        this.myClaims = await (<any>this.claimService.getClaims());
      }
    }

    if (!this.userRole.auditor) {
      this.commCenterService.loadMessages();
    }

    if (
      this.userRole.auditor &&
      this.accessclients != undefined &&
      this.accessclients.length >= 1
    ) {
      this.formGroup.controls['clients'].valueChanges.subscribe((val) => {
        if (val != this.session.SelectedContNum) {
          const clientData = this.accessclients.filter(
            (item) => item.value === val,
          );
          if (clientData[0] != null) {
            const selected = this.auditorClients.find(
              (client) => client.contNum === clientData[0].value,
            );
            this.session.SetSelectedClient(
              clientData[0].value,
              selected?.clientName ?? clientData[0].label,
            );
            this.session.ChangeClient(val);
            //debugger;
            this.session.reloadAuditorDashboard();
          }

          //this.refreshValues();
        }
      });
    }

    if (this.accessclients.length > 1 && this.session.SelectedContNum != '-1') {
      this.formGroup.controls['clients'].setValue(this.session.SelectedContNum);
    } else if (this.accessclients.length === 1) {
      this.formGroup.controls['clients'].setValue(this.accessclients[0].value);
    }
  }

  async displayAnnouncements() {
    if (
      (this.session.hideAnnouncements &&
        this.session.user.role !== 'AUDITOR' &&
        this.hasEulaAgreement) ||
      this.hasEulaAgreement === undefined ||
      sessionStorage.getItem('closed-announcements') === 'true'
    ) {
      return;
    }

    if (this.session.user.isEmulating) {
      this.session.hideAnnouncements = false;
    }
    // only show these once per session
    this.session.hideAnnouncements =
      this.session.user.role === 'AUDITOR' ? false : true;

    this.announcements = await this.http.get<Announcements[]>(
      `/api/user/Announcements`,
    );
    if (this.announcements && this.announcements.length > 0) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        announcements: this.announcements,
      };

      if (this.dialogRefAnnouncements) {
        this.dialog.open(this.dialogRefAnnouncements, dialogConfig);
      }
    }
  }
  async clientChange() {
    this.formGroup.controls['clients'].value;
  }

  async loadDelegationFeatures() {
    const delegationFeatures = await this.display.delegationFeatures();
    this.showDelegationMenu = delegationFeatures.showDelegationMenu;
    this.actAsDelegate = this.display.actAsDelegateSignal();
    this.manageDelegates = delegationFeatures.manageOwnDelegates;
    this.manageOthersDelegators = delegationFeatures.manageOthersDelegates;
  }

  async refreshValues() {
    this.isClaimant = this.userRole.claimant;
    this.isEmployee = this.userRole.employee;
    this.isAuditor = this.userRole.auditor;
    this.isInternalAuditor =
      this.session.user.userType === 'INTERNALAUDITOR' ? true : false;
    this.isManager = this.session.user.roles.manager;
    this.isController = this.session.user.roles.controller;
    this.terminated = this.session.user.emulatorContext?.isTerminated;
    this.hasWorkSchedule = this.display.myWorkSchedule;

    //setup visibility for nav menu and header items
    this.showMyClaims = this.isClaimant || this.isEmployee ? true : false;
    this.showHistory = this.display.history;
    this.showSearch =
      this.isClaimant ||
      this.isEmployee ||
      this.isAuditor ||
      !this.session.user.clientCustomizations.ClaimSearch
        ? false
        : true;
    this.showWatchlist = this.display.watchList;
    await this.config.initializeConfig();
    this.hasReportClaim = this.display.reportClaim;
    if (this.hasReportClaim) {
      this.reportClaimLabel = await this.aliases.get('ReportClaim');
    }
    if (this.session.user.role !== 'AUDITOR') {
      this.commCenterService.loadMessages();
    }
    if (!this.isAuditor || this.session.user.isEmulating) {
      this.displayAnnouncements();
    }
    this.isIncidentalClient = this.hasIncidentalAbsence();

    if (this.isController) {
      this.showMenu = 'Manager View';
    }
  }

  tryClose(
    drawer: MatDrawer,
    routerLink: string,
    tabName: string,
    featureName: string,
    queryParams: any,
  ) {
    if (drawer && drawer?.mode === 'over') {
      drawer.close();
    }
    this.LogFeature(featureName.replaceAll(/\s/g, ''), tabName, 'Navigation');

    if (routerLink != null && routerLink != undefined) {
      if (queryParams != undefined && queryParams != null) {
        this.router.navigate([routerLink], {
          queryParams,
        });
      } else {
        this.router.navigate([routerLink]);
      }
    } else {
      if (featureName == 'OutboundSSO') {
        if (
          (this.outboundSSO == undefined || this.outboundSSO == null) &&
          this.display.outboundSSO != null
        ) {
          this.outboundSSO = this.display.outboundSSO;
        }
        if (
          this.outboundSSO != undefined &&
          this.outboundSSO != null &&
          this.outboundSSO.length > 0
        ) {
          const inx = this.outboundSSO.findIndex(
            (x) => x.ssoType.toLowerCase() == 'leavelink',
          );
          if (inx > -1) {
            this.leaveLinkAccessService.handleLeaveLinkAccess();
          }
        }
      }
    }
  }

  showReportAbsence() {
    if (this.config.getConfigFeatureAccess('leavelinksso')) {
      return false;
    } else {
      return (
        /*
        KP: Checking here that user is not delegating so, in left nav it will not display list of intermittent absences.
        Delegator is always going to be Manager
      */
        !this.session.isDelegating() &&
        this.display.reportIntermittentAbsence &&
        this.myClaims &&
        this.myClaims.findIndex(
          (claim) =>
            claim.status === 'Open' &&
            claim.lineOfBusiness === 'LV' &&
            claim.claimDescription.toLowerCase().indexOf('intermittent') > -1 &&
            claim.claimLevelFeatures.indexOf('submitintermittentabsences') > -1,
        ) > -1
      );
    }
  }

  reportClaim(drawer: MatDrawer) {
    this.LogFeature('ReportNewClaim', 'Report New Claim', 'Navigation');
    if (!this.userRole.manager && this.showReportAbsence()) {
      this.dialog.open(this.dialogRefReportNewClaimList, {
        panelClass: 'claimListDialog',
      });
    } else {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        title: 'Confirmation',
      };
      const dlg = this.dialog.open(this.dialogRefReportNewClaim, dialogConfig);
      // this one already has padding
      dlg.updateSize('700px', '380px');
      this.tryClose(drawer, null, 'Report a New Claim', 'ReportClaim', null);
    }
  }

  LogFeature(featureName: string, tabName: string, navigationName: string) {
    this.FeatureLogging(featureName, tabName, navigationName);
  }

  onScroll(event: Event) {
    this.scrolled = (event.target as HTMLElement).scrollTop > 0;

    // fire custom event so nested components can react to scrolling.
    // This is needed as scrollbar is on a div rather than window object.
    // const scrollEvent = new Event("app:layout:scroll");
    this.messageBus.publish('layout:scroll', event);
  }

  acceptedEulaAgreement(event: boolean) {
    this.hasEulaAgreement = event;

    if (this.hasEulaAgreement == false) {
      this.displayAnnouncements();
    }
  }

  /*   async hasIncidental() {
    this.isIncidentalClient = this.display.incidentalClient;
    this.hasWorkSchedule = this.display.myWorkSchedule;
  } */

  hasIncidentalAbsence(): boolean {
    return (
      this.config.getConfigFeatureAccess('IncidentalAbsences5') ||
      this.config.getConfigFeatureAccess('IncidentalAbsence')
    );
  }

  async logOut() {
    if (
      this.session.isEmulating$ &&
      this.session.user.emulatorContext != null
    ) {
      this.dialog.open(this.dialogRefLogoutConfirmation);
    } else {
      await sessionStorage.removeItem('eulaAccepted');
      await this.session.RemoveSelectedClient();
      await this.session.logoff();
    }
  }
  /*
  async redirecttosearch() {
    this.router.navigate(['search']);
  } */

  async redirectToHome() {
    if (this.session.user.isEmulating) {
      await this.session.stopEmulation('/');
    } else {
      this.router.navigate(['/']);
    }
  }

  getDashboardRoute(): string {
    return this.isController ? '/controller' : '/dashboard';
  }

  endDelegationConfirmation() {
    const dialogConfigDelegation = new MatDialogConfig();
    dialogConfigDelegation.ariaLabelledBy = 'confirmEndDelegation';
    this.dialog.open(this.removeDialog, dialogConfigDelegation);
  }

  async endDelegation(event: any) {
    event.preventDefault();
    const result = await this.session.endDelegation();
    if (result) {
      switch (true) {
        case this.userRole.supervisor:
          this.router.navigate(['/act-as-delegate']);
          break;
        case this.userRole.employee:
          this.router.navigate(['/act-as-delegate']);
          break;
        case this.userRole.overseer:
          this.router.navigate(['/act-as-delegate']);
          break;
        case this.userRole.omni:
          this.router.navigate(['/act-as-delegate']);
          break;
        default:
      }
    }
  }

  getUserDisplayName() {
    return this.titleCase.transform(this.session.user.firstName);
  }

  redirectToOwnMgrDashboard() {
    this.router.navigate(['supervisor'], {});
  }

  async redirectToPreferences(tabName: string) {
    if (this.session.user.isEmulating) {
      await this.session.stopEmulation('/PreferencesPage');
    } else {
      if(tabName != null && tabName != undefined) {
        this.router.navigate(['PreferencesPage'], { queryParams: { focus: tabName } });
      } else {
        this.router.navigate(['PreferencesPage']);
      }
    }
  }

  openTopHeaderNavigation(
    routerLink: string,
    tabName: string,
    featureName: string,
    navigationName: string,
  ) {
    this.LogFeature(featureName.replaceAll(/\s/g, ''), tabName, navigationName);
    if (routerLink !== null && routerLink !== undefined && routerLink !== '') {
      this.router.navigate([routerLink]);
    } else if (featureName == 'Accountsettings') {
      this.redirectToPreferences(tabName);
    } else if (featureName == 'Home') {
      this.redirectToHome();
    } else if (featureName == 'CommunicationCenter') {
      this.router.navigate([routerLink]);
    }
  }
}
